function setPriceAccordionState(toggle, content, chevron, isOpen) {
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

    if (chevron) {
        chevron.classList.toggle('rotate-180', isOpen);
    }

    content.classList.toggle('opacity-100', isOpen);
    content.classList.toggle('opacity-0', !isOpen);

    // Toggle logo visibility
    const logo = document.querySelector('[data-price-block-logo]');

    if (isOpen) {
        // Start fading in logo immediately while accordion expands
        if (logo) {
            logo.style.opacity = '1';
            logo.style.pointerEvents = 'auto';
        }

        content.style.maxHeight = content.scrollHeight + 'px';
        window.setTimeout(() => {
            if (toggle.getAttribute('aria-expanded') === 'true') {
                content.style.maxHeight = 'none';
            }
        }, 300);
        return;
    }

    // Hide logo when closing accordion (instantly)
    if (logo) {
        logo.style.opacity = '0';
        logo.style.pointerEvents = 'none';
    }

    content.style.maxHeight = content.scrollHeight + 'px';
    content.getBoundingClientRect();
    content.style.maxHeight = '0px';
}

export function initPrice() {
    document.querySelectorAll('[data-price-block-toggle]').forEach((toggle) => {
        if (toggle._priceBlockBound) return;
        toggle._priceBlockBound = true;

        const contentId = toggle.getAttribute('aria-controls');
        const content = contentId ? document.getElementById(contentId) : null;
        const chevron = toggle.querySelector('[data-price-block-chevron]');

        if (!content) return;

        toggle.addEventListener('click', () => {
            const isOpen = toggle.getAttribute('aria-expanded') === 'true';
            setPriceAccordionState(toggle, content, chevron, !isOpen);
        });
    });
}
